import React, { useEffect, useRef } from 'react';
import {
  Avatar,
  CircularProgress,
  ListItem,
  ListItemAvatar,
  ListItemButton,
  ListItemText,
  Stack,
} from '@mui/material';
import ColoredUserAvatar from '../../../components/ColoredUserAvatar';

// Avatar redondo do "+" em "Adicionar leads" e "Nova lista".
export const AddAvatar = ({ children }) => (
  <Avatar sx={{ bgcolor: 'primary.main', color: 'primary.contrastText' }}>{children}</Avatar>
);

export const leadName = (lead) => lead.contact?.display_name || lead.contact?.phone_number || '';

// Lead numa lista das telas de lista: avatar, nome e telefone.
// `onClick` deixa a linha clicável; `action` vai à direita (remover, checkbox).
export const LeadListItem = ({ lead, onClick, action }) => {
  const content = (
    <>
      <ListItemAvatar>
        <ColoredUserAvatar name={leadName(lead)} />
      </ListItemAvatar>
      <ListItemText
        primary={leadName(lead)}
        secondary={lead.contact?.phone_number}
        slotProps={{ primary: { noWrap: true } }}
      />
    </>
  );

  if (onClick) {
    return (
      <ListItem disablePadding secondaryAction={action}>
        <ListItemButton onClick={onClick} sx={{ px: 0 }}>{content}</ListItemButton>
      </ListItem>
    );
  }
  return <ListItem disableGutters secondaryAction={action}>{content}</ListItem>;
};

// Rolagem infinita: quando este marcador aparece na tela, busca a próxima página.
export const LoadMoreSentinel = ({ hasNextPage, isFetchingNextPage, onLoadMore }) => {
  const ref = useRef(null);

  useEffect(() => {
    const node = ref.current;
    if (!node || !hasNextPage || typeof IntersectionObserver === 'undefined') return undefined;
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting && !isFetchingNextPage) onLoadMore();
    });
    observer.observe(node);
    return () => observer.disconnect();
  }, [hasNextPage, isFetchingNextPage, onLoadMore]);

  if (!hasNextPage) return null;
  return (
    <Stack ref={ref} alignItems="center" py={2}>
      {isFetchingNextPage && <CircularProgress size={20} />}
    </Stack>
  );
};
